var styles = {"styled-range":"Range_styled-range_lpitp_1","range-track-wrapper":"Range_range-track-wrapper_lpitp_12","left-range-track":"Range_left-range-track_lpitp_18","right-range-track":"Range_right-range-track_lpitp_19","thumb":"Range_thumb_lpitp_48","scale":"Range_scale_lpitp_58","reward-lock":"Range_reward-lock_lpitp_109"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
